import { defineComponent } from 'vue-demi';
import { s as script$2 } from './OrChip-354bd93f.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, withModifiers, Fragment, renderList, createBlock, createElementVNode, withCtx, renderSlot, createCommentVNode, createVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';
import { s as script$3 } from './OrLabel-a7d99df4.js';
import { s as script$4 } from './OrError-f90296db.js';

const OR_CHIPS_VALUE_PROP = {
  type: Array,
  default: () => []
};
const PLACEHOLDER_PROP = {
  type: String,
  default: ''
};

var script$1 = defineComponent({
  name: 'OrChipsInput',
  components: {
    OrChip: script$2
  },
  props: {
    chips: OR_CHIPS_VALUE_PROP,
    placeholder: PLACEHOLDER_PROP,
    input: {
      type: String,
      default: ''
    },
    duplicateAtIndex: {
      type: Number,
      default: -1
    },
    isFocused: Boolean,
    isDisabled: Boolean,
    isInvalid: Boolean
  },
  emits: ['add-chip', 'delete-chip', 'input-change', 'focus', 'blur'],
  computed: {
    placeholderText() {
      return this.chips && this.chips.length ? '' : this.placeholder;
    },
    states() {
      return {
        error: this.isInvalid,
        disabled: this.isDisabled
      };
    }
  },
  watch: {
    isFocused: {
      handler(isFocused) {
        const ref = this.$refs['or-chips-input'];
        if (ref) {
          isFocused ? ref.focus() : ref.blur();
        }
      },
      immediate: true
    }
  },
  methods: {
    getOrChipColor(index) {
      return this.duplicateAtIndex === index ? 'error' : '';
    },
    /* Help user to put input in focus by clicking on empty space  */
    handleContentClick(event) {
      const CONTENT_CLASS = 'or-chips-input';
      const target = event.target;
      if (target.classList.contains(CONTENT_CLASS)) {
        this.$emit('focus');
      }
    }
  }
});

const _hoisted_1$1 = ["value", "placeholder", "disabled"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_chip = resolveComponent("or-chip");
  return openBlock(), createElementBlock("form", {
    class: normalizeClass(["or-chips-input", _ctx.states]),
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.handleContentClick && _ctx.handleContentClick(...args)),
    onSubmit: _cache[3] || (_cache[3] = withModifiers($event => _ctx.$emit('add-chip'), ["prevent"]))
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.chips, (item, index) => {
    return openBlock(), createBlock(_component_or_chip, {
      key: index,
      content: item,
      color: _ctx.getOrChipColor(index),
      "is-disabled": _ctx.isDisabled,
      onDelete: $event => _ctx.$emit('delete-chip', index)
    }, null, 8 /* PROPS */, ["content", "color", "is-disabled", "onDelete"]);
  }), 128 /* KEYED_FRAGMENT */)), createElementVNode("input", {
    ref: "or-chips-input",
    value: _ctx.input,
    placeholder: _ctx.placeholderText,
    disabled: _ctx.isDisabled,
    class: "or-chips-input-element",
    onInput: _cache[0] || (_cache[0] = $event => _ctx.$emit('input-change', $event.target.value)),
    onBlur: _cache[1] || (_cache[1] = $event => _ctx.$emit('blur'))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1$1)], 34 /* CLASS, NEED_HYDRATION */);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-4beb72e1 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-4beb72e1 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-chips-input[data-v-4beb72e1] {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 0.125rem 0.5rem;\n  background-color: var(--c-neutral-1);\n  border: 1px solid var(--c-neutral-2);\n  border-radius: 0.25rem;\n}\n.or-chips-input.error[data-v-4beb72e1] {\n  border-color: var(--c-error);\n}\n.or-chips-input.disabled[data-v-4beb72e1] {\n  cursor: not-allowed;\n}\n.or-chips-input.disabled .or-chips-input-element[data-v-4beb72e1] {\n  cursor: not-allowed;\n}\n.or-chips-input-element[data-v-4beb72e1] {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 1.875rem;\n  margin: 0 0.125rem;\n  font-size: var(--fs-1);\n  background: transparent;\n  border: none;\n  outline: none;\n}\n.or-chips-input .or-chip[data-v-4beb72e1] {\n  margin: 0.125rem;\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-4beb72e1";
script$1.__file = "src/components/or-chips/partials/OrChipsInput.vue";

var script = defineComponent({
  name: 'OrChips',
  components: {
    OrChipsInput: script$1,
    OrLabel: script$3,
    OrError: script$4
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: OR_CHIPS_VALUE_PROP,
    placeholder: PLACEHOLDER_PROP,
    isRequired: Boolean,
    isDisabled: Boolean,
    isInvalid: Boolean
  },
  emits: ['update:modelValue', 'blur', 'focus', 'add-chip', 'delete-chip'],
  data() {
    return {
      input: '',
      duplicateAtIndex: -1,
      isFocused: false
    };
  },
  computed: {
    hasDuplicates() {
      return this.duplicateAtIndex !== -1;
    }
  },
  watch: {
    input: {
      handler() {
        this.checkForDuplicates();
      },
      immediate: true
    },
    modelValue: {
      handler() {
        this.checkForDuplicates();
      },
      immediate: true
    }
  },
  methods: {
    handleFocus() {
      this.isFocused = true;
      this.$emit('focus');
    },
    handleAddChip(args) {
      const isNotEmpty = !!this.input;
      const hasNoDuplicate = this.duplicateAtIndex === -1;
      if (isNotEmpty && hasNoDuplicate) {
        const value = [...this.modelValue, this.input];
        this.input = '';
        this.$emit('update:modelValue', value);
      }
      this.isFocused = !args.blur;
      if (!this.isFocused) {
        this.$emit('blur', this.modelValue);
      }
      this.$emit('add-chip', this.modelValue);
    },
    handleDeleteChip(index) {
      const value = [...this.modelValue];
      value.splice(index, 1);
      this.$emit('update:modelValue', value);
      this.$emit('delete-chip', value);
    },
    checkForDuplicates() {
      const input = this.input.trim();
      this.duplicateAtIndex = this.modelValue.findIndex(chip => {
        return chip === input;
      });
    }
  }
});

const _hoisted_1 = ["data-is-invalid"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_label = resolveComponent("or-label");
  const _component_or_chips_input = resolveComponent("or-chips-input");
  const _component_or_error = resolveComponent("or-error");
  return openBlock(), createElementBlock("div", {
    class: "or-chips",
    "data-is-invalid": _ctx.hasDuplicates || _ctx.isInvalid
  }, [_ctx.label ? (openBlock(), createBlock(_component_or_label, {
    key: 0,
    label: _ctx.label,
    "is-required": _ctx.isRequired
  }, {
    append: withCtx(() => [renderSlot(_ctx.$slots, "label-append")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["label", "is-required"])) : createCommentVNode("v-if", true), createVNode(_component_or_chips_input, {
    input: _ctx.input,
    chips: _ctx.modelValue,
    placeholder: _ctx.placeholder,
    "is-focused": _ctx.isFocused,
    "is-disabled": _ctx.isDisabled,
    "is-invalid": _ctx.isInvalid,
    "duplicate-at-index": _ctx.duplicateAtIndex,
    onInputChange: _cache[0] || (_cache[0] = $event => _ctx.input = $event),
    onFocus: _ctx.handleFocus,
    onBlur: _cache[1] || (_cache[1] = $event => _ctx.handleAddChip({
      blur: true
    })),
    onAddChip: _cache[2] || (_cache[2] = $event => _ctx.handleAddChip({
      blur: false
    })),
    onDeleteChip: _ctx.handleDeleteChip
  }, null, 8 /* PROPS */, ["input", "chips", "placeholder", "is-focused", "is-disabled", "is-invalid", "duplicate-at-index", "onFocus", "onDeleteChip"]), _ctx.isInvalid ? (openBlock(), createBlock(_component_or_error, {
    key: 1,
    error: _ctx.error
  }, null, 8 /* PROPS */, ["error"])) : createCommentVNode("v-if", true)], 8 /* PROPS */, _hoisted_1);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-a470dcbc {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-a470dcbc {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-chips[data-v-a470dcbc] {\n  display: flex;\n  flex-direction: column;\n}\n.or-chips .or-label[data-v-a470dcbc] {\n  margin-bottom: var(--s-1);\n}\n.or-chips .or-error[data-v-a470dcbc] {\n  margin-top: var(--s-1);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-a470dcbc";
script.__file = "src/components/or-chips/OrChips.vue";

export { script as s };
